module.exports = __webpack_public_path__ + "static/media/machine-learning.cff8cee8.svg";